import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const arrivalDateValidator: ValidatorFn = (group: FormGroup): ValidationErrors => {
  const arrivalDateCtrl = group.controls ? group.controls.arrivalDate : null;
  const birthDateCtrl = group.controls ? group.controls.chickBirthDate : null;
  if (!!arrivalDateCtrl && !!birthDateCtrl) {
    if (new Date(birthDateCtrl.value) > new Date(arrivalDateCtrl.value)) {
      arrivalDateCtrl.setErrors({ arrivalDateBeforeBirthDate: true });
    } else {
      arrivalDateCtrl.setErrors(null);
    }
  }
  return;
};
